

import React from 'react'
import LayoutModal from '../../Layout/Dashboard/LayoutModal'
import FormStaticInfo from './FormStaticInfo'
import { useAddStaticInfo } from '../../api/StaticInfo'
import { getDataToSend, getInitialValues, getValidationSchema } from './formUtil'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useTranslation } from 'react-i18next'

function AddStaticInfoModal() {


  const [t] = useTranslation()
  const {mutate , status} = useAddStaticInfo()
  const handelSubmit = (values:any )=>{

    const dataToSend = getDataToSend(values)

    mutate(dataToSend)
    // Submit Value
  }
  return (
    <LayoutModal
    
     isAddModal={true}
     getInitialValues={getInitialValues()} 
     handleSubmit={handelSubmit} 
     status={status as QueryStatusEnum}
     headerText={t('Add') +t('StaticInfo')}
     
     getValidationSchema={getValidationSchema()}>

    <FormStaticInfo />
  </LayoutModal>
  )
}

export default AddStaticInfoModal

